var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-row",
        { staticClass: "statistics-cards mb20", attrs: { gutter: 20 } },
        [
          _c("el-col", { attrs: { xs: 24, sm: 12, md: 6, lg: 6, xl: 6 } }, [
            _c("div", { staticClass: "stat-card total-card" }, [
              _c("div", { staticClass: "stat-icon" }, [
                _c("i", { staticClass: "el-icon-office-building" }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-content" }, [
                _c("div", { staticClass: "stat-value" }, [
                  _vm._v(_vm._s(_vm.statistics.totalUnions || 0)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "stat-label" }, [_vm._v("工会总数")]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("el-col", { attrs: { xs: 24, sm: 12, md: 6, lg: 6, xl: 6 } }, [
            _c("div", { staticClass: "stat-card active-card" }, [
              _c("div", { staticClass: "stat-icon" }, [
                _c("i", { staticClass: "el-icon-check" }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-content" }, [
                _c("div", { staticClass: "stat-value" }, [
                  _vm._v(_vm._s(_vm.statistics.activeUnions || 0)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "stat-label" }, [_vm._v("活跃工会")]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("el-col", { attrs: { xs: 24, sm: 12, md: 6, lg: 6, xl: 6 } }, [
            _c("div", { staticClass: "stat-card member-card" }, [
              _c("div", { staticClass: "stat-icon" }, [
                _c("i", { staticClass: "el-icon-user" }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-content" }, [
                _c("div", { staticClass: "stat-value" }, [
                  _vm._v(_vm._s(_vm.statistics.totalMembers || 0)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "stat-label" }, [_vm._v("会员总数")]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("el-col", { attrs: { xs: 24, sm: 12, md: 6, lg: 6, xl: 6 } }, [
            _c("div", { staticClass: "stat-card discount-card" }, [
              _c("div", { staticClass: "stat-icon" }, [
                _c("i", { staticClass: "el-icon-price-tag" }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-content" }, [
                _c("div", { staticClass: "stat-value" }, [
                  _vm._v(_vm._s(_vm.statistics.discountUnions || 0)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "stat-label" }, [_vm._v("折扣工会")]),
              ]),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-card",
        { staticClass: "box-card union-card" },
        [
          _c("div", { staticClass: "toolbar" }, [
            _c(
              "div",
              { staticClass: "title" },
              [
                _c("i", { staticClass: "el-icon-office-building title-icon" }),
                _vm._v(" "),
                _c("span", [_vm._v("工会信息")]),
                _vm._v(" "),
                _c(
                  "el-tag",
                  {
                    staticClass: "ml10",
                    attrs: { type: "info", size: "mini" },
                  },
                  [_vm._v("共 " + _vm._s(_vm.listData.total || 0) + " 条")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "actions" },
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "hasPermi",
                        rawName: "v-hasPermi",
                        value: ["admin:union:create"],
                        expression: "['admin:union:create']",
                      },
                    ],
                    attrs: {
                      type: "primary",
                      size: "small",
                      icon: "el-icon-plus",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.openEdit()
                      },
                    },
                  },
                  [_vm._v("新增工会")]
                ),
                _vm._v(" "),
                _c(
                  "el-dropdown",
                  {
                    directives: [
                      {
                        name: "hasPermi",
                        rawName: "v-hasPermi",
                        value: ["admin:union:batch"],
                        expression: "['admin:union:batch']",
                      },
                    ],
                    attrs: { size: "small" },
                    on: { command: _vm.handleBatchAction },
                  },
                  [
                    _c(
                      "el-button",
                      { attrs: { size: "small", icon: "el-icon-more" } },
                      [
                        _vm._v("\n            批量操作"),
                        _c("i", {
                          staticClass: "el-icon-arrow-down el-icon--right",
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-dropdown-menu",
                      { attrs: { slot: "dropdown" }, slot: "dropdown" },
                      [
                        _c(
                          "el-dropdown-item",
                          { attrs: { command: "batchDelete" } },
                          [_vm._v("批量删除")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-dropdown-item",
                          { attrs: { command: "batchEnable" } },
                          [_vm._v("批量启用")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-dropdown-item",
                          { attrs: { command: "batchDisable" } },
                          [_vm._v("批量禁用")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-dropdown",
                  {
                    attrs: { size: "small" },
                    on: { command: _vm.handleImportExport },
                  },
                  [
                    _c(
                      "el-button",
                      { attrs: { size: "small", icon: "el-icon-download" } },
                      [
                        _vm._v("\n            导入导出"),
                        _c("i", {
                          staticClass: "el-icon-arrow-down el-icon--right",
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-dropdown-menu",
                      { attrs: { slot: "dropdown" }, slot: "dropdown" },
                      [
                        _c(
                          "el-dropdown-item",
                          { attrs: { command: "export" } },
                          [_vm._v("导出数据")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-dropdown-item",
                          { attrs: { command: "template" } },
                          [_vm._v("下载模板")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-dropdown-item",
                          { attrs: { command: "import" } },
                          [_vm._v("导入数据")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-dropdown",
                  {
                    attrs: { size: "small" },
                    on: { command: _vm.handleSyncAction },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "small",
                          icon: "el-icon-refresh",
                          loading: _vm.syncLoading,
                        },
                      },
                      [
                        _vm._v("\n            数据同步"),
                        _c("i", {
                          staticClass: "el-icon-arrow-down el-icon--right",
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-dropdown-menu",
                      { attrs: { slot: "dropdown" }, slot: "dropdown" },
                      [
                        _c(
                          "el-dropdown-item",
                          { attrs: { command: "fullSync" } },
                          [
                            _c("i", { staticClass: "el-icon-refresh" }),
                            _vm._v(" 全量同步\n            "),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-dropdown-item",
                          { attrs: { command: "syncUnionBase" } },
                          [
                            _c("i", { staticClass: "el-icon-office-building" }),
                            _vm._v(" 同步工会信息\n            "),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-dropdown-item",
                          { attrs: { command: "syncUnionUser" } },
                          [
                            _c("i", { staticClass: "el-icon-user" }),
                            _vm._v(" 同步会员数据\n            "),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-dropdown-item",
                          { attrs: { divided: "", command: "goToSyncPage" } },
                          [
                            _c("i", { staticClass: "el-icon-setting" }),
                            _vm._v(" 高级同步设置\n            "),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { size: "small", icon: "el-icon-setting" },
                    on: {
                      click: function ($event) {
                        _vm.columnVisible = true
                      },
                    },
                  },
                  [_vm._v("列设置")]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-collapse",
            {
              staticClass: "filter-collapse",
              model: {
                value: _vm.filterCollapse,
                callback: function ($$v) {
                  _vm.filterCollapse = $$v
                },
                expression: "filterCollapse",
              },
            },
            [
              _c(
                "el-collapse-item",
                { attrs: { title: "高级筛选", name: "1" } },
                [
                  _c(
                    "el-form",
                    {
                      staticClass: "filter-form",
                      attrs: {
                        inline: "",
                        size: "small",
                        "label-width": "100px",
                      },
                      nativeOn: {
                        submit: function ($event) {
                          $event.preventDefault()
                        },
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "工会名称" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth",
                              attrs: {
                                placeholder: "输入工会名称",
                                clearable: "",
                              },
                              model: {
                                value: _vm.query.name,
                                callback: function ($$v) {
                                  _vm.$set(_vm.query, "name", $$v)
                                },
                                expression: "query.name",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                },
                                on: { click: _vm.doSearch },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "统一社会信用代码" } },
                        [
                          _c("el-input", {
                            staticClass: "selWidth",
                            attrs: { placeholder: "信用代码", clearable: "" },
                            model: {
                              value: _vm.query.social_credit_code,
                              callback: function ($$v) {
                                _vm.$set(_vm.query, "social_credit_code", $$v)
                              },
                              expression: "query.social_credit_code",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "负责人" } },
                        [
                          _c("el-input", {
                            staticClass: "selWidth",
                            attrs: { placeholder: "负责人姓名", clearable: "" },
                            model: {
                              value: _vm.query.leader,
                              callback: function ($$v) {
                                _vm.$set(_vm.query, "leader", $$v)
                              },
                              expression: "query.leader",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "是否开启折扣" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth",
                              attrs: { placeholder: "全部", clearable: "" },
                              model: {
                                value: _vm.query.openDiscount,
                                callback: function ($$v) {
                                  _vm.$set(_vm.query, "openDiscount", $$v)
                                },
                                expression: "query.openDiscount",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { value: 1, label: "已开启" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { value: 0, label: "未开启" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "创建时间" } },
                        [
                          _c("el-date-picker", {
                            staticClass: "selWidth",
                            attrs: {
                              type: "daterange",
                              "range-separator": "至",
                              "start-placeholder": "开始日期",
                              "end-placeholder": "结束日期",
                              "value-format": "yyyy-MM-dd",
                              "unlink-panels": "",
                              "picker-options":
                                _vm.$timeOptions.datePickerOptions,
                            },
                            model: {
                              value: _vm.query.dateRange,
                              callback: function ($$v) {
                                _vm.$set(_vm.query, "dateRange", $$v)
                              },
                              expression: "query.dateRange",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                size: "small",
                                icon: "el-icon-search",
                              },
                              on: { click: _vm.doSearch },
                            },
                            [_vm._v("查询")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", icon: "el-icon-refresh" },
                              on: { click: _vm.resetSearch },
                            },
                            [_vm._v("重置")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "mt10",
              attrs: {
                data: _vm.listData.list,
                size: "mini",
                "header-cell-style": { fontWeight: "bold" },
                stripe: "",
                "row-key": "id",
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _vm._v(" "),
              _vm.visibleColumns.id
                ? _c("el-table-column", {
                    attrs: { prop: "id", label: "ID", width: "80" },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.visibleColumns.logo
                ? _c("el-table-column", {
                    attrs: { label: "Logo", width: "80" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("el-avatar", {
                                attrs: {
                                  size: 32,
                                  src: scope.row.logo,
                                  icon: "el-icon-picture-outline",
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1442735961
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.visibleColumns.name
                ? _c("el-table-column", {
                    attrs: {
                      prop: "name",
                      label: "工会名称",
                      "min-width": "200",
                      "show-overflow-tooltip": true,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.visibleColumns.abbreviation
                ? _c("el-table-column", {
                    attrs: {
                      prop: "abbreviation",
                      label: "简称",
                      "min-width": "120",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.visibleColumns.social_credit_code
                ? _c("el-table-column", {
                    attrs: {
                      prop: "social_credit_code",
                      label: "信用代码",
                      "min-width": "160",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.visibleColumns.leader
                ? _c("el-table-column", {
                    attrs: {
                      prop: "leader",
                      label: "负责人",
                      "min-width": "120",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.visibleColumns.leader_phone
                ? _c("el-table-column", {
                    attrs: {
                      prop: "leader_phone",
                      label: "负责人手机",
                      "min-width": "140",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.visibleColumns.billing_period
                ? _c("el-table-column", {
                    attrs: {
                      prop: "billing_period",
                      label: "账期(天)",
                      width: "100",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.visibleColumns.discount_status
                ? _c("el-table-column", {
                    attrs: { label: "折扣状态", width: "100" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: scope.row.openDiscount
                                      ? "success"
                                      : "info",
                                    size: "mini",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        scope.row.openDiscount
                                          ? "已开启"
                                          : "未开启"
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2385520077
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.visibleColumns.created_at
                ? _c("el-table-column", {
                    attrs: { label: "创建时间", "min-width": "160" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(_vm._s(_vm.formatCreatedAt(scope.row))),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2636489823
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  width: "180",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "action-buttons-icon" },
                          [
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: "查看详情",
                                  placement: "top",
                                  "open-delay": 500,
                                },
                              },
                              [
                                _c("el-button", {
                                  staticClass: "action-icon-btn",
                                  attrs: {
                                    size: "mini",
                                    type: "primary",
                                    icon: "el-icon-view",
                                    plain: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.showDetail(scope.row)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: "编辑工会",
                                  placement: "top",
                                  "open-delay": 500,
                                },
                              },
                              [
                                _c("el-button", {
                                  staticClass: "action-icon-btn",
                                  attrs: {
                                    size: "mini",
                                    type: "success",
                                    icon: "el-icon-edit",
                                    plain: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openEdit(scope.row)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: "会员管理",
                                  placement: "top",
                                  "open-delay": 500,
                                },
                              },
                              [
                                _c("el-button", {
                                  staticClass: "action-icon-btn",
                                  attrs: {
                                    size: "mini",
                                    type: "info",
                                    icon: "el-icon-user",
                                    plain: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.goMembers(scope.row)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: "删除工会",
                                  placement: "top",
                                  "open-delay": 500,
                                },
                              },
                              [
                                _c("el-button", {
                                  staticClass: "action-icon-btn",
                                  attrs: {
                                    size: "mini",
                                    type: "danger",
                                    icon: "el-icon-delete",
                                    plain: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.doDelete(scope.row)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            staticClass: "mt10",
            attrs: {
              "current-page": _vm.query.page,
              "page-sizes": _vm.constants.page.limit,
              layout: _vm.constants.page.layout,
              total: _vm.listData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.editDialogTitle,
            visible: _vm.editDialog.visible,
            width: "800px",
            "before-close": _vm.closeEdit,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.editDialog, "visible", $event)
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "editForm",
              staticClass: "form-grid",
              attrs: {
                model: _vm.editDialog.form,
                rules: _vm.editRules,
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "工会名称", prop: "name" } },
                        [
                          _c("el-input", {
                            attrs: { maxlength: "255", "show-word-limit": "" },
                            model: {
                              value: _vm.editDialog.form.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.editDialog.form, "name", $$v)
                              },
                              expression: "editDialog.form.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "工会简称", prop: "abbreviation" } },
                        [
                          _c("el-input", {
                            attrs: { maxlength: "100", "show-word-limit": "" },
                            model: {
                              value: _vm.editDialog.form.abbreviation,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.editDialog.form,
                                  "abbreviation",
                                  $$v
                                )
                              },
                              expression: "editDialog.form.abbreviation",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "统一社会信用代码",
                            prop: "social_credit_code",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { maxlength: "50" },
                            model: {
                              value: _vm.editDialog.form.social_credit_code,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.editDialog.form,
                                  "social_credit_code",
                                  $$v
                                )
                              },
                              expression: "editDialog.form.social_credit_code",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "账期(天)", prop: "billing_period" },
                        },
                        [
                          _c("el-input", {
                            attrs: { maxlength: "20" },
                            model: {
                              value: _vm.editDialog.form.billing_period,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.editDialog.form,
                                  "billing_period",
                                  $$v
                                )
                              },
                              expression: "editDialog.form.billing_period",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "负责人", prop: "leader" } },
                        [
                          _c("el-input", {
                            attrs: { maxlength: "100" },
                            model: {
                              value: _vm.editDialog.form.leader,
                              callback: function ($$v) {
                                _vm.$set(_vm.editDialog.form, "leader", $$v)
                              },
                              expression: "editDialog.form.leader",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "负责人手机号",
                            prop: "leader_phone",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { maxlength: "20" },
                            model: {
                              value: _vm.editDialog.form.leader_phone,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.editDialog.form,
                                  "leader_phone",
                                  $$v
                                )
                              },
                              expression: "editDialog.form.leader_phone",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "是否开启折扣",
                            prop: "openDiscount",
                          },
                        },
                        [
                          _c("el-switch", {
                            attrs: { "active-value": 1, "inactive-value": 0 },
                            model: {
                              value: _vm.editDialog.form.openDiscount,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.editDialog.form,
                                  "openDiscount",
                                  $$v
                                )
                              },
                              expression: "editDialog.form.openDiscount",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "折扣率(0-100)",
                            prop: "discount_rate",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { maxlength: "10" },
                            model: {
                              value: _vm.editDialog.form.discount_rate,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.editDialog.form,
                                  "discount_rate",
                                  $$v
                                )
                              },
                              expression: "editDialog.form.discount_rate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "超期关闭折扣",
                            prop: "expired_close_discount",
                          },
                        },
                        [
                          _c("el-switch", {
                            attrs: { "active-value": 1, "inactive-value": 0 },
                            model: {
                              value: _vm.editDialog.form.expired_close_discount,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.editDialog.form,
                                  "expired_close_discount",
                                  $$v
                                )
                              },
                              expression:
                                "editDialog.form.expired_close_discount",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-form-item", { attrs: { label: "Logo" } }, [
                        _c(
                          "div",
                          { staticClass: "upload-row" },
                          [
                            _c("el-avatar", {
                              staticClass: "mr10",
                              attrs: {
                                size: 50,
                                src: _vm.editDialog.form.logo,
                                icon: "el-icon-picture-outline",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini" },
                                on: { click: _vm.pickLogo },
                              },
                              [_vm._v("选择图片")]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c("el-form-item", { attrs: { label: "证照" } }, [
                        _c(
                          "div",
                          { staticClass: "upload-row" },
                          [
                            _c(
                              "div",
                              { staticClass: "license-list" },
                              _vm._l(_vm.licenses, function (img, idx) {
                                return _c("el-image", {
                                  key: idx,
                                  staticClass: "license-thumb",
                                  attrs: { src: img, fit: "cover", lazy: "" },
                                })
                              }),
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini" },
                                on: { click: _vm.pickLicenses },
                              },
                              [_vm._v("添加证照")]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "简介", prop: "synopsis" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 4,
                              maxlength: "1000",
                              "show-word-limit": "",
                            },
                            model: {
                              value: _vm.editDialog.form.synopsis,
                              callback: function ($$v) {
                                _vm.$set(_vm.editDialog.form, "synopsis", $$v)
                              },
                              expression: "editDialog.form.synopsis",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("el-button", { on: { click: _vm.closeEdit } }, [
                _vm._v("取消"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitEdit } },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "工会详情",
            visible: _vm.detailDialog.visible,
            width: "900px",
            "before-close": _vm.closeDetail,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.detailDialog, "visible", $event)
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "detail-form" },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c("div", { staticClass: "form-section-title" }, [
                      _c("i", { staticClass: "el-icon-office-building" }),
                      _vm._v("\n            基本信息\n          "),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "form-item-readonly" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _c("i", { staticClass: "el-icon-office-building" }),
                        _vm._v(" 工会名称"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-value" }, [
                        _vm._v(_vm._s(_vm.detailDialog.data.name || "-")),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "form-item-readonly" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _c("i", { staticClass: "el-icon-star-off" }),
                        _vm._v(" 工会简称"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-value" }, [
                        _vm._v(
                          _vm._s(_vm.detailDialog.data.abbreviation || "-")
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "form-item-readonly" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _c("i", { staticClass: "el-icon-postcard" }),
                        _vm._v(" 统一社会信用代码"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-value" }, [
                        _vm._v(
                          _vm._s(_vm.detailDialog.data.socialCreditCode || "-")
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "form-item-readonly" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _c("i", { staticClass: "el-icon-user" }),
                        _vm._v(" 会员数量"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-value" },
                        [
                          _c("el-tag", { attrs: { type: "primary" } }, [
                            _vm._v(
                              _vm._s(_vm.detailDialog.data.memberCount || 0) +
                                " 人"
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "form-item-readonly" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _c("i", { staticClass: "el-icon-user" }),
                        _vm._v(" 活跃会员数"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-value" },
                        [
                          _c("el-tag", { attrs: { type: "success" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.detailDialog.data.activeMemberCount || 0
                              ) + " 人"
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "form-item-readonly" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _c("i", { staticClass: "el-icon-date" }),
                        _vm._v(" 创建时间"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-value" }, [
                        _vm._v(_vm._s(_vm.detailDialog.data.createdAt || "-")),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c("div", { staticClass: "form-section-title" }, [
                      _c("i", { staticClass: "el-icon-user" }),
                      _vm._v("\n            联系信息\n          "),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "form-item-readonly" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _c("i", { staticClass: "el-icon-user-solid" }),
                        _vm._v(" 负责人"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-value" }, [
                        _vm._v(_vm._s(_vm.detailDialog.data.leader || "-")),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "form-item-readonly" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _c("i", { staticClass: "el-icon-phone" }),
                        _vm._v(" 负责人手机"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-value" }, [
                        _vm._v(
                          _vm._s(_vm.detailDialog.data.leaderPhone || "-")
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "form-item-readonly" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _c("i", { staticClass: "el-icon-user" }),
                        _vm._v(" 法定代表人"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-value" }, [
                        _vm._v(
                          _vm._s(_vm.detailDialog.data.juridicalPerson || "-")
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "form-item-readonly" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _c("i", { staticClass: "el-icon-phone" }),
                        _vm._v(" 法人手机"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-value" }, [
                        _vm._v(
                          _vm._s(
                            _vm.detailDialog.data.juridicalPersonPhone || "-"
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c("div", { staticClass: "form-section-title" }, [
                      _c("i", { staticClass: "el-icon-money" }),
                      _vm._v("\n            财务信息\n          "),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "form-item-readonly" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _c("i", { staticClass: "el-icon-bank-card" }),
                        _vm._v(" 对公账户"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-value" }, [
                        _vm._v(
                          _vm._s(_vm.detailDialog.data.corporateAccount || "-")
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "form-item-readonly" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _c("i", { staticClass: "el-icon-office-building" }),
                        _vm._v(" 开户行"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-value" }, [
                        _vm._v(
                          _vm._s(
                            _vm.detailDialog.data.corporateAccountBank || "-"
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "form-item-readonly" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _c("i", { staticClass: "el-icon-credit-card" }),
                        _vm._v(" 银行卡号"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-value" }, [
                        _vm._v(
                          _vm._s(
                            _vm.detailDialog.data.corporateAccountBankCard ||
                              "-"
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "form-item-readonly" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _c("i", { staticClass: "el-icon-time" }),
                        _vm._v(" 账期(天)"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-value" }, [
                        _vm._v(
                          _vm._s(_vm.detailDialog.data.billingPeriod || 0) +
                            " 天"
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "form-item-readonly" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _c("i", { staticClass: "el-icon-discount" }),
                        _vm._v(" 是否开启折扣"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-value" },
                        [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type: _vm.detailDialog.data.openDiscount
                                  ? "success"
                                  : "danger",
                              },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.detailDialog.data.openDiscount
                                      ? "是"
                                      : "否"
                                  ) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.detailDialog.data.openDiscount
                    ? _c("el-col", { attrs: { span: 12 } }, [
                        _c("div", { staticClass: "form-item-readonly" }, [
                          _c("label", { staticClass: "form-label" }, [
                            _c("i", { staticClass: "el-icon-discount" }),
                            _vm._v(" 折扣率"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-value" }, [
                            _vm._v(
                              _vm._s(_vm.detailDialog.data.discountRate) + "%"
                            ),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.detailDialog.data.synopsis ||
                  _vm.detailDialog.data.logo ||
                  _vm.formatLicenses(_vm.detailDialog.data.licenses).length > 0
                    ? _c("el-col", { attrs: { span: 24 } }, [
                        _c("div", { staticClass: "form-section-title" }, [
                          _c("i", { staticClass: "el-icon-document" }),
                          _vm._v("\n            其他信息\n          "),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.detailDialog.data.logo
                    ? _c("el-col", { attrs: { span: 12 } }, [
                        _c("div", { staticClass: "form-item-readonly" }, [
                          _c("label", { staticClass: "form-label" }, [
                            _c("i", { staticClass: "el-icon-picture-outline" }),
                            _vm._v(" Logo"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-value" },
                            [
                              _c("el-avatar", {
                                attrs: {
                                  size: 60,
                                  src: _vm.detailDialog.data.logo,
                                  icon: "el-icon-picture-outline",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.detailDialog.data.synopsis
                    ? _c("el-col", { attrs: { span: 24 } }, [
                        _c("div", { staticClass: "form-item-readonly" }, [
                          _c("label", { staticClass: "form-label" }, [
                            _c("i", { staticClass: "el-icon-document" }),
                            _vm._v(" 工会简介"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-value" }, [
                            _vm._v(_vm._s(_vm.detailDialog.data.synopsis)),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.formatLicenses(_vm.detailDialog.data.licenses).length > 0
                    ? _c("el-col", { attrs: { span: 24 } }, [
                        _c("div", { staticClass: "form-item-readonly" }, [
                          _c("label", { staticClass: "form-label" }, [
                            _c("i", { staticClass: "el-icon-folder-opened" }),
                            _vm._v(" 证照资料"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-value" }, [
                            _c(
                              "div",
                              { staticClass: "license-list" },
                              _vm._l(
                                _vm.formatLicenses(
                                  _vm.detailDialog.data.licenses
                                ),
                                function (img, idx) {
                                  return _c("el-image", {
                                    key: idx,
                                    staticClass: "license-thumb",
                                    attrs: {
                                      src: img,
                                      fit: "cover",
                                      lazy: "",
                                      "preview-src-list": _vm.formatLicenses(
                                        _vm.detailDialog.data.licenses
                                      ),
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.closeDetail } },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "列设置",
            visible: _vm.columnVisible,
            width: "400px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.columnVisible = $event
            },
          },
        },
        [
          _c(
            "el-checkbox-group",
            {
              model: {
                value: _vm.selectedColumns,
                callback: function ($$v) {
                  _vm.selectedColumns = $$v
                },
                expression: "selectedColumns",
              },
            },
            _vm._l(_vm.columnOptions, function (label, key) {
              return _c("el-checkbox", { key: key, attrs: { label: key } }, [
                _vm._v(_vm._s(label)),
              ])
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.columnVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.saveColumnSettings },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "导入工会信息",
            visible: _vm.importVisible,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.importVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "import-content" },
            [
              _c(
                "el-alert",
                {
                  staticClass: "mb15",
                  attrs: {
                    title: "导入说明",
                    type: "info",
                    closable: false,
                    "show-icon": "",
                  },
                },
                [
                  _c(
                    "div",
                    { attrs: { slot: "description" }, slot: "description" },
                    [
                      _c("p", [
                        _vm._v("1. 请先下载导入模板，按照模板格式填写数据"),
                      ]),
                      _vm._v(" "),
                      _c("p", [_vm._v("2. 支持Excel格式文件（.xlsx, .xls）")]),
                      _vm._v(" "),
                      _c("p", [_vm._v("3. 每次最多导入1000条记录")]),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "ButtonUploadExcel",
                { attrs: { beforeUpload: _vm.beforeImport } },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary", icon: "el-icon-upload" } },
                    [_vm._v("选择文件")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.importVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }